import PhotoSessions from 'containers/PhotoSessions';
import NotFoundPage from 'components/NotFoundPage';
import createPhotoSessionsRoutes from './photoSessions';
import createPaymentsRoutes from './payments';
import createChecklistRoutes from './checklist';
import createIssueReportRoutes from './issueReport';
import createAnnouncementSteps from './announcementSteps';
import createProfileLoadable from './profile';
import createPropertyAssessmentRoutes from './propertyAssessment';
import ROUTES, { routesNames } from './constants';
import { onEnterLoggedIn, onChangeLoggedIn } from './utils';

const loggedInRoutes = (store) => [
  {
    name: 'onlyForLoggedUsers',
    childRoutes: [
      {
        path: ROUTES.BASE_PATH,
        name: routesNames.notStartedPhotoSessions,
        component: PhotoSessions,
        exact: true,
      },
      ...createPhotoSessionsRoutes(),
      ...createChecklistRoutes(),
      ...createIssueReportRoutes(),
      ...createAnnouncementSteps(),
      ...createProfileLoadable(),
      ...createPropertyAssessmentRoutes(),
      ...createPaymentsRoutes(),
    ],
    onEnter: onEnterLoggedIn(store),
    onChange: onChangeLoggedIn(store),
  },
];

const getRoutes = (store) => [
  ...loggedInRoutes(store),
  {
    path: '*',
    name: 'notFound',
    component: NotFoundPage,
  },
];

export default getRoutes;
